import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Radio from '@material-ui/core/Radio'
import clsx from 'clsx'

const useStyles = makeStyles({
  root: {
    color: '#B0B0B0',
    width: '24px',
    height: '24px',
  },
  checked: (pr) => ({
    color: pr.color || '#B0B0B0',
  }),
  colorSecondary: {
    checked: (pr) => ({
      color: pr.color || '#B0B0B0',
    }),
  },
})

const RadioButton = ({ color, className, dataId, ...rest }) => {
  const classes = useStyles({ color })

  return (
    <Radio
      className={clsx(className)}
      classes={classes}
      color="default"
      inputProps={{
        ['data-id']: dataId,
      }}
      {...rest}
    />
  )
}

export default RadioButton
